var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('DataTable',{attrs:{"title":"משימות בטיפול כעת","show_delete":false,"show_edit":false,"show_header_filter":false,"operations":_vm.operations,"filters":_vm.filters,"sorters":_vm.sorters,"fields":_vm.fields,"response":_vm.data},on:{"create":_vm.createAlert,"info":_vm.showStatInfo}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }